var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"header"}),_c('div',{staticClass:"partner-container"},_vm._l((_vm.partners),function(partner){return _c('PartnerItem',{key:partner.key,class:_vm.partners.length == 4 ? 'partner-item-quad' : 'partner-item',attrs:{"name":partner.name,"text":partner.text,"imageUrl":partner.imageUrl,"link":partner.link}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }